import { UseMutationOptions } from '@tanstack/react-query';
import useAppMutation from 'hooks/useAppMutation';
import { BaseErrorResponse } from 'models/_base';
import API from 'services/API';
import { PricingPeriodsResetPayload } from './PropertyPricingModal.types';

type ResetPropertiesPricingArgs = PricingPeriodsResetPayload;

type ReactQueryMutationOptions = Omit<
  UseMutationOptions<unknown, unknown, ResetPropertiesPricingArgs>,
  'mutationFn' | 'mutationKey'
>;

const resetPropertiesPricing = async (payload: ResetPropertiesPricingArgs) => {
  return API.post<unknown, BaseErrorResponse>(
    'api/internal/pricing-periods/reset',
    payload,
  );
};

const useResetPropertiesPricingMutation = (
  options: ReactQueryMutationOptions = {},
) => {
  return useAppMutation({
    mutationFn: resetPropertiesPricing,
    ...options,
  });
};

export default useResetPropertiesPricingMutation;
